"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flag = void 0;

var tslib_1 = require("tslib");

var _3x2_1 = tslib_1.__importDefault(require("country-flag-icons/react/3x2"));

var react_1 = tslib_1.__importDefault(require("react"));

var Flag = function Flag(_a) {
  var regionCode = _a.regionCode,
      props = tslib_1.__rest(_a, ["regionCode"]);

  var RegionCodeFlag = _3x2_1.default[regionCode];
  return react_1.default.createElement(RegionCodeFlag, tslib_1.__assign({}, props, {
    "data-testid": "".concat(regionCode, "-flag")
  }));
};

exports.Flag = Flag;